import script from "./CreateRuleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateRuleForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateRuleForm.vue?vue&type=style&index=0&id=4d38f635&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d38f635"]])

export default __exports__